var map = {
	"./xl-anhui.jpg": 204,
	"./xl-fujian.jpg": 205,
	"./xl-guangdong.jpg": 206,
	"./xl-guangxi.jpg": 207,
	"./xl-hunan.jpg": 208,
	"./xl-shanxi.jpg": 209,
	"./xl-sichuan.jpg": 210,
	"./xl-yunnan.jpg": 211
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75;


//////////////////
// WEBPACK FOOTER
// ./src/images/active ^\.\/xl\-.*\.jpg$
// module id = 75
// module chunks = 1